import { useState, useLayoutEffect } from 'react'

const MOBILE_MEDIA_QUERY = '(max-width: 480px)'
const TABLET_SMALL_MEDIA_QUERY = '(min-width: 480px) and (max-width: 768px)'
const TABLET_MEDIA_QUERY = '(min-width: 768px) and (max-width: 1184px)'
const LAPTOP_MEDIA_QUERY = '(min-width: 1184px) and (max-width: 1440px)'
const DESKTOP_MEDIA_QUERY = '(min-width: 1440px) and (max-width: 1920px)'
const DESKTOP_LARGE_MEDIA_QUERY = '(min-width: 1920px)'

const TABLET_SMALL_OR_ABOVE_MEDIA_QUERY = '(min-width: 480px)'
const TABLET_OR_ABOVE_MEDIA_QUERY = '(min-width: 768px)'
const LAPTOP_OR_ABOVE_MEDIA_QUERY = '(min-width: 1184px)'
const DESKTOP_OR_ABOVE_MEDIA_QUERY = '(min-width: 1440px)'

export const useMediaQuery = (query: string) => {
  const [doesMatch, setDoesMatch] = useState(false)

  function handleChange(event: MediaQueryListEvent) {
    setDoesMatch(event.matches)
  }

  useLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(query)
    mediaQueryList.addEventListener('change', handleChange)
    setDoesMatch(mediaQueryList.matches)

    return () => {
      mediaQueryList.removeEventListener('change', handleChange)
    }
  }, [query])

  return doesMatch
}

export const useIsMobile = () => {
  return useMediaQuery(MOBILE_MEDIA_QUERY)
}

export const useIsTabletSmall = () => {
  return useMediaQuery(TABLET_SMALL_MEDIA_QUERY)
}

export const useIsTabletSmallOrAbove = () => {
  return useMediaQuery(TABLET_SMALL_OR_ABOVE_MEDIA_QUERY)
}

export const useIsTablet = () => {
  return useMediaQuery(TABLET_MEDIA_QUERY)
}

export const useIsTabletOrAbove = () => {
  return useMediaQuery(TABLET_OR_ABOVE_MEDIA_QUERY)
}

export const useIsLaptop = () => {
  return useMediaQuery(LAPTOP_MEDIA_QUERY)
}

export const useIsLaptopOrAbove = () => {
  return useMediaQuery(LAPTOP_OR_ABOVE_MEDIA_QUERY)
}

export const useIsDesktop = () => {
  return useMediaQuery(DESKTOP_MEDIA_QUERY)
}

export const useIsDesktopOrAbove = () => {
  return useMediaQuery(DESKTOP_OR_ABOVE_MEDIA_QUERY)
}

export const useIsDesktopLarge = () => {
  return useMediaQuery(DESKTOP_LARGE_MEDIA_QUERY)
}
